import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, input, Output, signal } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
// import { AppCheck } from '@angular/fire/app-check';
import { AuthService } from '../../../auth.service';
import { IAuthRequest, IAuthResponse } from '../../../types';
import { MatError, MatHint } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { NgxCountriesDropdownModule } from 'ngx-countries-dropdown';
import { RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha-2';
import { combineLatestWith, switchMap, take } from 'rxjs';
import { backend } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ConfirmPopup } from '../../../confirm.popup';

@Component({
  selector: 'auth-request',
  templateUrl: './auth-request.component.html',
  styleUrls: ['./auth-request.component.scss'],
  // providers: [ReCaptchaV3Service],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatHint, MatError, MatButton, NgxCountriesDropdownModule, RecaptchaV3Module],
  providers: [ReCaptchaV3Service]
})
export class AuthRequestComponent {

  selectedCountry: any;
  loading = signal<boolean>(false);
  phone = input<string|null>();
  relogin = input<boolean>(false);
  auth = inject(AuthService);
  recaptcha = inject(ReCaptchaV3Service);
  confirm = inject(ConfirmPopup);
  http = inject(HttpClient);
  toast = inject(ToastrService);

  buttonText = computed(() => {
    return this.relogin() ? 'Login' : 'Get Started';
  });

  @Output() response: EventEmitter<IAuthResponse & IAuthRequest> = new EventEmitter<IAuthResponse & IAuthRequest>();

  form: FormGroup = new FormGroup({
    country_code: new FormControl('356', [Validators.required]),
    phone: new FormControl('', [Validators.required, Validators.pattern(/[^a-zA-Z]/)])
  });

  constructor(){
    const fullPhone = this.phone();
    if(fullPhone){
      const [ country_code, phone ] = fullPhone.replace(/[^0-9+#]/gm, '').split(' ');
      this.form.reset({
        country_code,
        phone
      });
    }
  }


  requestVerification(): void {
    if(!this.form.valid){
      return;
    }

    this.loading.set(true);

    const userAuth: IAuthRequest = this.form.value;

    if(userAuth.phone.startsWith(userAuth.country_code) || userAuth.phone.startsWith(userAuth.country_code.replace('+', ''))){
      userAuth.phone = ('+'+userAuth.phone).replace('++','+').replace(userAuth.country_code, '');
    }
    
    this.recaptcha.execute('web_auth_request').pipe(
      take(1), 
      combineLatestWith(this.auth.getIP()),
      switchMap(([captcha, ip]) => this.http.post<IAuthResponse>(backend + 'auth/request', {...userAuth, token: captcha }, ip ? { headers: { cuip: ip } } : undefined))
    ).subscribe({
      next: response => {
        this.response.next({ ...response, ...userAuth });
        this.loading.set(false);
      },
      error: error => {
        error = (error.error || error);
        this.loading.set(false);

        if(error.code === 4){
          this.confirm.open('Account does not exist', error.message + '. To create an account, please use the cloudigo.app', 'Create account Prompt', [
            {
              label: 'Get the app',
              route: '/get-the-app',
              paint: 'primary',
              close: true
            }
          ], 'Close');
        } else {
          this.toast.error(error.message || 'Unknown error occurred');
        }
      }
    });
  }

}
